<template>
  <div class="px-5">
    <v-col cols="12" class="py-0 group-bread-scrumb">
        <router-link :to="{name: 'Promotion'}">
          Quản lý mã
        </router-link>
        <span> > </span>
        <router-link :to="{name: 'CreatePromotion'}">
          Thêm mới
        </router-link>
    </v-col>
    <div class="create-form">
      <validation-observer ref="validator" v-slot="{ handleSubmit }">
        <v-col cols="12">
          <div class="justify-end d-flex">
            <v-btn
              v-if="!promotion.id && checkAuthorization('oms-code_create') || promotion.id && checkAuthorization('oms-code_update')"
              class="btn-save"
              small
              @click.prevent="handleSubmit(savePromotion)"
              :disabled="isPending"
            >
              <span v-if="!promotion.id">Lưu</span>
              <span v-if="promotion.id">Cập nhật</span>
            </v-btn>

            <v-btn
              class="btn-cancel mx-0"
              small
              @click="cancel"
            >
              Quay lại
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12">
          <div class="group-form">
            <v-row>
              <v-col cols="12" class="py-0 pt-2 px-8">
                <h3>Tạo mã</h3>
              </v-col>
              <v-col cols="3" class="px-8 py-0 pt-2">
                <p class="text-bold mb-1">Mã*</p>
                <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{ required: true, regex: /^[A-Za-z0-9]+$/ }"
                  name="Mã"
                >
                  <v-text-field
                    class="text-field"
                    :error-messages="errors"
                    :clearable="true"
                    placeholder="Nhập mã"
                    outlined
                    dense
                    maxLength="20"
                    v-model="promotion.code"
                    @change="onChangeCode"
                  ></v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="3" class="px-8 py-0 pt-2">
                <p class="text-bold mb-1">Hình thức áp dụng*</p>
                <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{ required: true}"
                  name="Hình thức áp dụng"
                >
                  <v-select
                    class="text-field"
                    :error-messages="errors"
                    :clearable="true"
                    :items="campaignForms"
                    item-value="id"
                    item-text="name"
                    :aLight="'right'"
                    placeholder="Chọn"
                    attach
                    outlined
                    dense
                    v-model="promotion.type"
                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                  ></v-select>
                </validation-provider>
              </v-col>
            </v-row>
          </div>
        </v-col>

        <v-col cols="12" v-if="promotion.type === promotionGeneral">
          <div class="group-form">
            <v-row>
              <v-col cols="12 py-0 pt-2 px-8">
                <h3>Chi tiết</h3>
              </v-col>
              <v-col cols="3" class="px-8 py-0 pt-2">
                <p class="text-bold mb-1">Số lượt sử dụng tối đa*</p>
                <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{ required: true, min_value: 0, max: 10, alpha_num: true }"
                  name="Số lượt sử dụng tối đa"
                >
                  <v-text-field
                    class="text-field text-field-number"
                    :error-messages="errors"
                    :clearable="true"
                    placeholder="Nhập số lượt sử dụng tối đa"
                    outlined
                    dense
                    type="number"
                    v-model="promotion.numberOfAvailable"
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
          </div>
        </v-col>

        <v-col cols="12" v-if="promotion.type === promotionPrivate">
          <div class="group-form">
            <v-row>
              <v-col cols="12 py-0 pt-2 px-8">
                <h3>Chi tiết</h3>
              </v-col>
              <v-col cols="3" class="px-8 py-0 pt-2">
                <p class="text-bold mb-1">Độ dài của mã*</p>
                <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{ required: true, max_value: 99, min_value: promotion.code ? (promotion.code.length + 3) : 0, alpha_num: true }"
                  name="Độ dài của mã"
                >
                  <v-text-field
                    class="text-field text-field-number"
                    :error-messages="errors"
                    :clearable="true"
                    placeholder="Nhập độ dài"
                    outlined
                    dense
                    maxLength="2"
                    type="number"
                    v-model="promotion.codeLength"
                  ></v-text-field>
                </validation-provider>
              </v-col>

              <v-col cols="3" class="px-8 py-0 pt-2">
                <p class="text-bold mb-1">Số lượng mã riêng cần tạo*</p>
                <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{ required: true, min_value: 0, max_value: 500000, alpha_num: true }"
                  name="Số lượng mã riêng cần tạo"
                >
                  <v-text-field
                    class="text-field text-field-number"
                    :error-messages="errors"
                    :clearable="true"
                    placeholder="Nhập số lượng"
                    outlined
                    dense
                    type="number"
                    v-model="promotion.numberOfCode"
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="py-0 px-8">
                <span>Chú ý: Mã được tạo ra sẽ có cấu trúc [Mã][Phần ký tự còn thiếu được tạo random]</span>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import * as moment from 'moment';

import RepositoryFactory from '@/repositories/RepositoryFactory';
const PromotionRepository = RepositoryFactory.get('promotion');
const CampaignRepository = RepositoryFactory.get('campaign');

import {
  promotionGeneral,
  promotionPrivate,
} from '../../helpers/constants';

import Promotion from './models/Promotion'

import { formatDate } from "@/helpers/utils";

export default {
  name: 'detail',
  components: {
  },
  props:{
  },
  data() {
    return {
      promotion: new Promotion({}),
      campaignForms: [],
      promotionGeneral,
      promotionPrivate,
      isPending: false,
    };
  },
  computed: {
  },
  async created() {
    this.getListAttributes();
  },
  beforeDestroy() {
  },
  methods: {
    onChangeCode: _.debounce(function () {
      this.promotion.code = this.promotion.code.toUpperCase();
    }, 500),
    cancel() {
      this.$swal
        .fire({
          title: "Cảnh báo",
          text: "Bạn muốn đóng form? Tất cả thông tin sẽ bị mất!",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Hủy",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Đồng ý",
        })
        .then( async (result) => {
          if (result?.value) {
            this.$router.push('/promotion');
          }
        });
    },
    async savePromotion() {
      if (!this.promotion.id) {
        const promotion = {
          code: this.promotion.code,
          type: this.promotion.type,
        };

        if (this.promotion.type === this.promotionGeneral) {
          promotion.numberOfAvailable = this.promotion.numberOfAvailable;
        }

        if (this.promotion.type === this.promotionPrivate) {
          promotion.numberOfCode = this.promotion.numberOfCode;
          promotion.codeLength = this.promotion.codeLength;
        }

        this.isPending = true;
        const res = await PromotionRepository.create(promotion);
        this.isPending = false;
        if(res.data && res.data.id) {
          this.$swal({
            type: 'success',
            icon: "success",
            text: 'Tạo thành công',
            toast: true,
            timer: 1500,
          });

          return this.$router.push({name: 'Promotion'});
        }
        this.$swal({
          type: 'error',
          icon: "error",
          text: res.errors.message,
        });
      }

      if (this.promotion.id) {
      }
    },
    async getListAttributes() {
      const res = await CampaignRepository.getOptions();
      this.campaignForms = res.data.applicableForm;
    }
  }
};
</script>
<style scoped lang="scss">
  .btn-save {
    background: #8465FF !important;
    color: #fff;
  }
  .btn-cancel  {
    background: #787878 !important;
    color: #fff;
  }
  .create-form {
    background: #fff;
  }
  .group-form {
    background: #FAFBFF;
    border-radius: 10px;
    box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);
  }
  .text-bold {
    font-weight: bold;
  }

  .btn-info {
    background: #6587FF !important;
    color: #fff;
  }

  .icon-search {
    left: 40px;
    position: relative;
  }
</style>

<style lang="scss">
  .text-field fieldset {
    background: #fff !important;
  }
  .text-search {
    .v-input__slot {
      min-height: 20px !important;
      padding-left: 35px !important;
    }
  }

  .v-select-custom {
    .v-subheader {
      font-weight: bold;
      background: #ECECEC;
      color: #000;
    }
  }

  .group-bread-scrumb {
    position: relative;
    top: -30px;
    z-index: 99;
    height: 0;
    font-weight: bold;
    font-size: 17px;
    a {
      text-decoration: none !important;
      color: #000;
    }
  }
  .text-field-no-message {
    .v-text-field__details {
      display: none !important;
    }
  }
</style>
